var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot flex ai-c jc-c"},[_c('div',{staticClass:"foot-item"},[_c('div',[_vm._v(" © 2024-2026 广东省林业事务中心 版权所有 ")]),_c('div',[_vm._v(" ICP证："),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2024267156号")])]),_c('div',[_vm._v(" 联系方式：slyj_zrjy@gd.gov.cn ")])])])
}]

export { render, staticRenderFns }